import { type HTMLAttributes, type ReactNode } from 'react';

const cardVariants = {
  default: 'bg-white rounded-xl border border-gray-100',
  elevated: 'bg-white rounded-xl border border-gray-100 shadow-sm',
  bordered: 'bg-white rounded-xl border border-gray-200',
} as const;

const cardSizes = {
  compact: 'p-4',
  default: 'p-5',
  spacious: 'p-6',
} as const;

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof cardVariants;
  size?: keyof typeof cardSizes;
  children: ReactNode;
}

export function Card({ variant = 'default', size = 'default', className = '', children, ...props }: CardProps) {
  return (
    <div className={`${cardVariants[variant]} ${cardSizes[size]} ${className}`} {...props}>
      {children}
    </div>
  );
}
